module.exports = __webpack_public_path__ + "img/orders.e2000c7e.png";